import {enumContainer, formattedPropertyModel} from '@wallaby-ui/core';
import {forEach, map} from 'lodash';

import FilterParser from './filter_parser';
import {FilterToComponentStringOptions} from './filter_types';

const STATIC_EMPTY_ARRAY = [];
const PARAMS_I18N_PARAMS = 'i18nParams';

class FilterUtils {
  static getFilterMappedOptions(
    node,
    translateService,
    enumMap?: enumContainer.EnumMap
  ) {
    const enumName = node.getEnumName();
    const formatterParams = node.getFormatterParams();
    const mappedOptions =
      enumName && enumMap
        ? map(enumMap[enumName], (item) => ({
            value: item.name,
            label: item.messageKey
              ? formattedPropertyModel.FormattedProperty.formatLabel(
                  item.messageKey,
                  translateService,
                  item,
                  formatterParams[PARAMS_I18N_PARAMS]
                )
              : item.messageKey,
          }))
        : STATIC_EMPTY_ARRAY;
    return mappedOptions;
  }

  static filterToComponentString(
    filter,
    filterSchema,
    translateService,
    options?: FilterToComponentStringOptions
  ) {
    const node = filterSchema.getFilterByName(filter.getProperty());
    const isHierarchy = !!node.getHierarchyType();
    const isAsync = !!node.getEnumName();
    const mappedEnumOptions = this.getFilterMappedOptions(
      node,
      translateService,
      options?.enumMap
    );

    return filter.toComponentString(filterSchema, translateService, {
      hierarchyChildrenLabels: options?.hierarchyChildrenLabels,
      isHierarchy,
      autocompleteValues: options?.autocompleteValues,
      isAsync,
      mappedEnumOptions,
      organizations: options?.organizations,
      agens: options?.agens,
    });
  }

  static fromStringToComponentString(
    serializedFilter,
    filterSchema,
    translateService,
    options?: FilterToComponentStringOptions
  ) {
    const filters = FilterParser.fromString(serializedFilter, filterSchema);
    let componentString = '';

    forEach(filters, (filter, idx) => {
      const filterComponentString = this.filterToComponentString(
        filter,
        filterSchema,
        translateService,
        {
          hierarchyChildrenLabels: options?.hierarchyChildrenLabels,
          autocompleteValues: options?.autocompleteValues,
          organizations: options?.organizations,
          agens: options?.agens,
        }
      );

      componentString += filterComponentString;
      // if filter is not last
      if (idx < filters.length - 1) {
        componentString += ' & ';
      }
    });
    return componentString;
  }

  static getRangeFromString(serializedFilter) {
    const nameValueSepIdx = serializedFilter.indexOf(':');
    const property = serializedFilter.slice(0, nameValueSepIdx);
    const range = serializedFilter.slice(nameValueSepIdx + 1);
    const sepIdx = range.indexOf('TO');
    // remove quotes
    const rangeFrom = range.slice(1, sepIdx - 2).trim();
    const rangeTo = range.slice(sepIdx + 4, -1).trim();
    return {rangeFrom, rangeTo, property};
  }
}

export default FilterUtils;
